import * as React from 'react';
import { ITableStore } from '../Table';

export interface ITableBodyProps {
    /**
     * Internal tableStore data, applied automatically by parent.
     * @ignore
     */
    tableStore?: ITableStore;
}

interface IState {
    isOpen: boolean;
}

/**
 * Placeholder component for wrapping reasons.
 */
export default class TableBody extends React.Component<ITableBodyProps, IState> {
    static displayName: string = 'TableBody';

    render () {
        if (!this.props.tableStore) {
            return null;
        }
        const output: React.ReactElement[] = [];
        React.Children.map(this.props.children, (child) => {
            if (typeof child === 'string' || typeof child === 'number' || child === null) {
                return;
            }
            if (React.isValidElement(child)) {
                const extendedProps = {
                    tableStore: this.props.tableStore,
                };
                output.push(React.cloneElement(child, extendedProps));
            }
            return;
        });
        return (
            <React.Fragment>
                {output.map((child) => {
                    return child;
                })}
            </React.Fragment>
        );
    }
}
